// extracted by mini-css-extract-plugin
export default {"input":"Input_input__QMmaj","default":"Input_default__pZMfp","alternate":"Input_alternate__4pZbB"};